module.exports = __webpack_public_path__ + "media/packs/images/close-small-white-ac26e6b195a025213e853ca38d8a940d.svg";